import formGroupOriginCredentials from "./formGroupOriginCredentials";
import formGroupOriginDetail from "./formGroupOriginDetail";

export default {
  title: 'Add New Origin',
  attributeName: 'origin',
  createURL: 'origin',
  sessionParams: [],
  updateURL: 'origin',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  formConfig: [
    formGroupOriginDetail,
    formGroupOriginCredentials,
  ],
};
